import React, { useState } from "react";
import { Button, Card, CardBody, CardHeader, Chip } from "@nextui-org/react";
import { cleanUpExistingMetrics } from "../../controllers/APIController";
import { useParams } from "react-router-dom";

const CleanupForms = () => {
  const { _orgId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleCleanup = async () => {
    setIsLoading(true);
    setResult(null);

    try {
      const cleanupResult = await cleanUpExistingMetrics(_orgId);
      setResult(cleanupResult);
    } catch (error) {
      setResult({
        success: false,
        error: error.message,
        message: "Failed to clean up forms"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <Card className="w-full">
        <CardHeader className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold">Clean Up Existing Forms</h2>
          <p className="text-sm text-gray-600">
            This utility will remove guidance, overview, and reference fields from all existing forms in your organization.
            This action cannot be undone.
          </p>
        </CardHeader>
        <CardBody className="space-y-4">
          <div className="flex flex-col gap-4">
            <Button
              color="warning"
              variant="solid"
              onClick={handleCleanup}
              isLoading={isLoading}
              className="w-full"
            >
              {isLoading ? "Cleaning up forms..." : "Clean Up All Forms"}
            </Button>

            {result && (
              <div className="mt-4">
                <Chip
                  color={result.success ? "success" : "danger"}
                  variant="flat"
                  className="mb-2"
                >
                  {result.success ? "Success" : "Error"}
                </Chip>
                <p className="text-sm">{result.message}</p>
                {result.cleanedCount !== undefined && (
                  <p className="text-sm text-gray-600 mt-2">
                    Cleaned {result.cleanedCount} forms
                    {result.errorCount > 0 && `, ${result.errorCount} errors occurred`}
                  </p>
                )}
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default CleanupForms; 